type RecordedWork = {
  projectType?: string | null;
  projectTypes?: string[] | null;
  projectSummary?: string | null;
  description?: string | null;
};

function usableText(value: string | null | undefined): string | null {
  const text = value?.split(/[\r\n]/).find(line => line.trim())?.replace(/[_\s]+/g, " ").trim();
  if (!text || /^(?:(?:other|general|mixed|multiple)(?: building| construction)?(?: work| works| project)?|(?:building|construction)(?: work| works)?|project|quote|unknown|unspecified|n\/a|none|null|undefined|not specified|not available|no description provided|custom)$/i.test(text)) return null;
  return text;
}

/** Presentation only: use recorded words, never infer a job from priced items. */
export function generatedQuoteWorkTitle(work: RecordedWork): string {
  const type = usableText(work.projectType);
  const selected = work.projectTypes?.map(usableText).filter(Boolean).join(" + ");
  const recorded = type || selected || usableText(work.projectSummary) || usableText(work.description);
  if (!recorded) return "Generated quote — work not specified";
  const firstLine = recorded.split(/[\r\n]/)[0].replace(/^#+\s*/, "");
  const title = firstLine.length > 110 ? `${firstLine.slice(0, 107).replace(/\s+\S*$/, "")}…` : firstLine;
  return title.charAt(0).toUpperCase() + title.slice(1);
}
